import { render, staticRenderFns } from "./Strips.vue?vue&type=template&id=e8cf4abe&scoped=true"
import script from "./Strips.vue?vue&type=script&lang=js"
export * from "./Strips.vue?vue&type=script&lang=js"
import style0 from "./Strips.vue?vue&type=style&index=0&id=e8cf4abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cf4abe",
  null
  
)

export default component.exports